'use strict';

/**
 * Spain Spanish (es-ES).
 * Iberian phrasing and vocabulary (correo electrónico, contraseña, etc.).
 * Keep keys identical to en-AU.js.
 */
module.exports = {
  login: {
    trustLine:
      'La confianza de equipos de profesiones reguladas en todo el mundo — allí donde las conversaciones difíciles importan.',
    pitchTitle: 'Conversaciones reales, antes de que lo sean.',
    pitchBody:
      'Practica las conversaciones difíciles — la objeción, el diagnóstico, la mala noticia — y recibe comentarios mientras aún importan.',
    orgManagedSignIn: 'El acceso lo gestiona tu organización.',
    orgOnAudirie: '{name} en Audirie',
    welcomeBack: 'Bienvenido de nuevo.',
    findYourWayIn: 'Vamos a encontrar tu forma de acceso.',
    startWithWorkEmail: 'Empieza con tu correo electrónico del trabajo — te llevaremos por el camino adecuado.',
    workEmailTellsUs:
      'Tu correo electrónico del trabajo nos indica cómo inicia sesión tu organización. No hace falta contraseña si utilizan el inicio de sesión único.',
    workEmail: 'Correo electrónico',
    continue: 'Continuar',
    pickUpWhereLeftOff: 'Retoma justo donde lo dejaste.',
    continueAs: 'Continuar como {email}',
    singleSignOn: 'Inicio de sesión único',
    singleSignOnWithOrg: 'Inicio de sesión único · {orgName}',
    audiriePassword: 'Contraseña de Audirie',
    useDifferentAccount: 'Usar otra cuenta',
    oneMoment: 'Un momento…',
    checkingOrganisationSignIn: 'Estamos comprobando cómo inicia sesión tu organización.',
    whichOrgHeading: '¿Con cuál vas a iniciar sesión?',
    belongsToMultipleOrgs: '{email} pertenece a más de una organización en Audirie.',
    yourOrganisation: 'Tu organización',
    useDifferentEmail: 'Usar otro correo electrónico',
    orgTakesItFromHere: '{name} se encarga a partir de aquí',
    yourOrgTakesItFromHere: 'Tu organización se encarga a partir de aquí',
    openingTheirSignIn:
      'Estamos abriendo su página de acceso — terminarás allí y volverás aquí. Nada de lo que introduzcas en su página nos llega.',
    notYouStartAgain: '¿No eres tú? Empezar de nuevo',
    verifiedGettingReady: 'Ya estás verificado. Preparando tu espacio de práctica.',
    orgSignInComplete: 'El acceso de {name} se ha completado',
    accountNotReady: 'Tu cuenta aún no está lista',
    ssoWorkedButNeedsSetup:
      'El inicio de sesión único ha funcionado, pero tu cuenta de Audirie aún debe configurarse antes de poder entrar.',
    noRoleAssigned:
      'Tu cuenta todavía no tiene un rol asignado. Contacta con el administrador de tu organización.',
    backToLogin: 'Volver al inicio de sesión',
    orgDidntLetUsIn: '{name} no nos ha dejado entrar',
    couldntCompleteSso: 'No hemos podido completar el inicio de sesión único',
    orgSignInDeclined:
      'El servicio de acceso de tu organización ha rechazado la solicitud o no ha respondido. No hay nada malo en tu cuenta de Audirie.',
    ifKeepsHappening:
      'Si sigue ocurriendo, avisa a tu equipo de TI — y escríbenos a support@audirie.com para que podamos ayudarte.',
    tryAgain: 'Volver a intentarlo',
    orgSignedInAsSomeoneElse: '{name} tiene la sesión iniciada con otra persona',
    differentAccountSignedIn: 'Hay otra cuenta con la sesión iniciada',
    orgSignOnConnectedElsewhere:
      'El acceso de tu organización sigue conectado a otro correo electrónico en este navegador.',
    signOutCorporateFirst:
      'Cierra primero la sesión de esa cuenta corporativa y, a continuación, vuelve e inténtalo con el correo que quieras usar.',
    enterPassword: 'Introduce tu contraseña',
    change: 'cambiar',
    password: 'Contraseña',
    forgotPassword: '¿Has olvidado tu contraseña?',
    signIn: 'Iniciar sesión',
    resetPassword: 'Restablecer tu contraseña',
    wellEmailLink: 'Te enviaremos un correo con un enlace para elegir una nueva.',
    send: 'Enviar',
    cancel: 'Cancelar',
    emailRequired: 'El correo electrónico es obligatorio',
    emailAndPasswordRequired: 'El correo electrónico y la contraseña son obligatorios',
    emailNotFound: 'No se ha encontrado ese correo electrónico.',
    passwordIncorrect: 'Tu contraseña es incorrecta.',
    ssoUnavailable:
      'El inicio de sesión único no está disponible en este momento. Inicia sesión con tu contraseña.',
    popupBlocked:
      'Tu navegador ha bloqueado la ventana de acceso. Permite las ventanas emergentes en este sitio y, después, actualiza la página para continuar.',
    couldNotLogIn:
      'Lamentablemente no hemos podido iniciar tu sesión. Escribe a support@audirie.com si el problema persiste.',
    resetEmailSent:
      'Si el correo electrónico que has facilitado figura en nuestros registros, recibirás un mensaje con un enlace para restablecer tu contraseña.',
    needValidEmail: 'Facilítanos un correo electrónico válido.',
    mustRegisterFirst:
      'Debes registrarte en Audirie antes de poder completar esta tarea. Si no dispones de un enlace de registro, contacta con nosotros en support@audirie.com',
    couldNotResetPassword:
      'No hemos podido restablecer tu contraseña. Inténtalo de nuevo. Si el problema persiste, contacta con nosotros en support@audirie.com'
  }
};
